<template>
  <div class="p-y-2">
    <div class="text-bold text-lg"> {{subtaskName}} </div>
    <div v-if="review">
      {{(review.occupation_display_name) }} service
    </div>
    <div class="d-flex fd-column fd-row:d">

      <div>
        By<span class="text-semibold">
          {{ authorName }}</span>
        in <span class="text-semibold">
          {{ getLocation | location }}
        </span>
      </div>
    </div>
    <div class="c-gray60 m-b-1">{{ reviewDate }}</div>
    <div class="m-b-1 STARSIZE">
      <RatingStars :value="review.overall_rating"/>
    </div>
    <div class="layout">
      <div class="layout-item is-6 m-r-6:t">
        <div selenium="view-truncated-review" v-if="needsTruncating && !showFullReview" class="color-gray70 m-b-2">
          {{ truncatedReview }} ...
          <span
              class="link"
              @click="showFullReview = true">
            Show more
          </span>
        </div>

        <div
            selenium="view-full-review"
            class="color-gray70 m-b-2"
            v-else-if="truncateNotReview && showFullReview">
          {{ review.review_comment }}
          <span class="link" @click="showFullReview = false">Show Less</span>
        </div>
        <div
            selenium="view-profile-comments"
            class="color-gray70 m-b-2"
            v-else>{{ review.review_comment}}</div>
      </div>
      <div v-if="!isModal" class="layout-item is-4">
        <div v-if="!$device.isMobile">
          <review-categories v-if="review.category_rating" :categories="review.category_rating"  />
        </div>
      </div>
    </div>
    <gallery class="m-b-2" v-if= this.review.assets :files="review.assets"/>
    <div v-if="$device.isMobile" class="m-r-6:mo">
      <review-categories v-if="review.category_rating" :categories="review.category_rating" />
    </div>
    <div v-if="isModal">
      <div v-if="!$device.isMobile">
        <review-categories v-if="review.category_rating" :categories="review.category_rating"  />
      </div>
    </div>
  </div>

</template>

<script>
import { format } from 'date-fns';
import ReviewCategories from '@/components/ReviewCategories';

export default {
  name: 'review-with-pics',
  components: {
    ReviewCategories,
  },
  props: {
    review: {
      type: Object,
      required: true,
    },
    isModal: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      showFullReview: false,
    };
  },
  computed: {
    authorName () {
      return this.review.author_name ? this.review.author_name : 'Pro Referral Customer';
    },
    subtaskName () {
      return this.review.service_display_name;
    },
    reviewDate () {
      return format(new Date(this.review.created_dtm), 'MMM dd, yyyy');
    },
    getLocation () {
      // Remove zipcode from the location filter
      const modifiedLocation = Object.assign({}, this.review.location);
      delete modifiedLocation.zipcode;
      return modifiedLocation;
    },
    needsTruncating () {
      return this.review.review_comment.length > 275;
    },
    truncatedReview () {
      return this.review.review_comment.slice(0, this.review.review_comment.slice(0, 275).lastIndexOf(' '));
    },
    truncateNotReview () {
      return this.review.review_comment.length;
    },

  },
};
</script>
<style lang="scss" scoped>
    .STARSIZE {
      font-size: 22px;
    }
</style>
